import React from 'react';

const PDFAnalysisOptions = ({ options, onOptionsChange }) => {
  return (
    <div className="mb-4 space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          요약 수준
        </label>
        <select
          className="w-full border border-gray-300 rounded-md px-3 py-2"
          value={options.summaryType}
          onChange={(e) => onOptionsChange({ ...options, summaryType: e.target.value })}
        >
          <option value="brief">간단 요약 (3문장)</option>
          <option value="standard">상세 요약 (5-7문장)</option>
          <option value="detailed">종합 분석 (10문장+)</option>
        </select>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          분석 관점
        </label>
        <select
          className="w-full border border-gray-300 rounded-md px-3 py-2"
          value={options.analysisType}
          onChange={(e) => onOptionsChange({ ...options, analysisType: e.target.value })}
        >
          <option value="general">일반적 관점</option>
          <option value="business">비즈니스 관점</option>
          <option value="technical">기술적 관점</option>
        </select>
      </div>
    </div>
  );
};

export default PDFAnalysisOptions; 